import React, { useEffect } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import {
  updateClarificationType,
  postClarificationType,
  getClarificationType,
  deleteClarificationType,
} from "../../../_redux/actions/ActionSettings";
import { connect } from "react-redux";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import { useState } from "react";

const AddTemplateType = ({
  postClarificationType,
  getClarificationType,
  clarificationType,
  deleteClarificationType,
  updateClarificationType,
  setShowAddType,
}) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    getClarificationType();
  }, [getClarificationType]);

  const { register, handleSubmit, reset, setValue } = useForm({
    mode: "onBlur",
    defaultValues: {},
  });

  const onSubmit = (formData) => {
    if (data) {
      updateClarificationType(formData, data.id);
      setData(null);
      reset();
    } else {
      postClarificationType(formData);
      setShowAddType(false);
      reset();
    }
  };
  return (
    <Card>
      <Card.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col md={4}>
              <Form.Group controlId="formGroupName">
                <Form.Label>Template Type Title</Form.Label>

                <div className="position-relative">
                  <Form.Control
                    type="text"
                    {...register("clarification_type")}
                    placeholder="eg: Confusion"
                  />
                  {data && (
                    <AiOutlineClose
                      className="position-absolute "
                      size={18}
                      style={{
                        top: "50%",
                        right: "8px",
                        transform: "translate(0,-50%)",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setData(null);
                        setValue("clarification_type", "");
                      }}
                    />
                  )}
                </div>
              </Form.Group>
            </Col>
            <Col md={8}>
              <div className="scroll-wrapper">
                <Row>
                  {clarificationType.length > 0 &&
                    clarificationType.map((item, index) => (
                      <Col md={6}>
                        <div className="question-type-list d-flex align-items-center justify-content-between">
                          <p>{item.clarification_type}</p>
                          <div>
                            <FaEdit
                              className="text-info pointer mr-1"
                              onClick={() => {
                                setValue(
                                  "clarification_type",
                                  item.clarification_type
                                );
                                setData(item);
                              }}
                            />
                            <FaTrashAlt
                              color="#BC2A20"
                              size={14}
                              className="pointer"
                              onClick={() => deleteClarificationType(item.id)}
                            />
                          </div>
                        </div>
                      </Col>
                    ))}
                </Row>
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={2}>
              <Button className="btn-primary btn-round btn-sm" type="submit">
                {data ? "Edit" : "Add"}
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  clarificationType: state.clarificationType.clarificationType,
});

const mapDispatchToProps = {
  postClarificationType,
  deleteClarificationType,
  getClarificationType,
  updateClarificationType,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddTemplateType);
